
import heroBg from '../../../assets/hero-bg.png';

interface HeroProps {
  onApplyClick: () => void;
}

export default function Hero({ onApplyClick }: HeroProps) {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={heroBg}
          alt="咲くら庵の店内"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 text-center px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto w-full">
        <div className="mb-6">
          <span className="inline-block bg-white/95 text-pink-500 px-6 py-2 rounded-full text-sm font-bold shadow-lg">
            個室型メンズエステ
          </span>
        </div>

        <h1 className="text-3xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
          安心・安全な環境で<br className="hidden sm:block" />
          <span className="text-pink-300">高収入</span>を実現
        </h1>

        <p className="text-base sm:text-xl text-white/95 mb-8 leading-relaxed max-w-2xl mx-auto">
          大阪・難波駅から徒歩8分。個室型だから安心して働けます。<br className="hidden sm:block" />
          あなたのライフスタイルに合わせた自由な働き方を。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={onApplyClick}
            className="w-full sm:w-auto bg-pink-500 text-white px-10 py-4 rounded-full text-base font-bold hover:bg-pink-600 transition-all shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-line-fill mr-2"></i>
            LINEで応募する
          </button>
          <button
            onClick={() => {
              const element = document.getElementById('features');
              if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            className="w-full sm:w-auto bg-white/95 text-gray-800 px-10 py-4 rounded-full text-base font-bold hover:bg-white transition-all shadow-xl hover:shadow-2xl whitespace-nowrap cursor-pointer"
          >
            詳しく見る
          </button>
        </div>

        <div className="mt-12 flex flex-wrap items-center justify-center gap-8 text-white">
          <div className="flex items-center gap-2">
            <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full backdrop-blur-sm">
              <i className="ri-shield-check-line text-xl"></i>
            </div>
            <span className="text-sm font-medium">個室型</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full backdrop-blur-sm">
              <i className="ri-time-line text-xl"></i>
            </div>
            <span className="text-sm font-medium">自由シフト</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full backdrop-blur-sm">
              <i className="ri-money-dollar-circle-line text-xl"></i>
            </div>
            <span className="text-sm font-medium">高収入保証</span>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-8 h-8 flex items-center justify-center text-white/80">
          <i className="ri-arrow-down-line text-2xl"></i>
        </div>
      </div>
    </section>
  );
}
